import React from "react";

import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormControlLabel,
  Checkbox,
  Divider,
  AutocompleteField,
  Typography,
} from "@tiny/components";
import { subscribersStatuses } from "../SubscribersList.helpers";
import { useFilterSubscribersDialog } from "./FilterSubscribersDialog.hooks";
import { FilterSubscribersDialogProps } from "./FilterSubscribersDialog.types";

function FilterSubscribersDialog(props: FilterSubscribersDialogProps) {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <FilterSubscribersDialogContent {...props} />
    </Dialog>
  );
}

function FilterSubscribersDialogContent(props: FilterSubscribersDialogProps) {
  const { onClose } = props;

  const {
    selectAll,
    allChecked,
    save,
    selectStatus,
    isSelected,
    customerTags,
    statusesLength,
    tagsLength,
    tags,
    setTags,
  } = useFilterSubscribersDialog(props);

  return (
    <>
      <DialogTitle onClose={onClose}>Filters</DialogTitle>
      <DialogContent>
        <Typography
          component="h2"
          variant="h4"
          fontWeight="bold"
          mt={0}
          color="grey"
          tone={900}
        >
          Status ({statusesLength})
        </Typography>
        <Grid container spacing={7} verticalSpacing={3}>
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label={"All"}
              checked={allChecked}
              onChange={(event: React.ChangeEvent<{}>, checked) =>
                selectAll(checked)
              }
            />
          </Grid>
          {subscribersStatuses.map((status) => (
            <Grid key={status} item xs={12} md={6}>
              <FormControlLabel
                control={<Checkbox color="primary" />}
                label={status}
                checked={isSelected(status)}
                onChange={(event: React.ChangeEvent<{}>, checked) =>
                  selectStatus(status, checked)
                }
              />
            </Grid>
          ))}
        </Grid>
        <Typography
          component="h2"
          variant="h4"
          fontWeight="bold"
          color="grey"
          tone={900}
        >
          Tags ({tagsLength})
        </Typography>
        <AutocompleteField
          options={customerTags}
          label="Tags"
          multiple
          freeSolo
          getOptionLabel={(option: string) => option}
          autoSelect
          value={tags}
          onChangeValue={setTags}
        />
        <Divider mt={4} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={save}>
          Save
        </Button>
      </DialogActions>
    </>
  );
}

export default FilterSubscribersDialog;
